import React from 'react';
import { Link } from 'react-router-dom';
import './EventCard.css';
import { placeholder } from '../../../photos/index.js';
import { useLanguage } from '../../../context/LanguageContext.jsx';
import { TranslatedText } from '../../i18n/TranslatedText.jsx';

const EventCard = ({ event }) => {
  const { isEnglish } = useLanguage();

  if (!event || event.status === 'pending' || event.status === 'rejected') {
    return null;
  }

  return (
    <Link to={`/etkinlik/${event.id}`} className="event-link">
      <div className="event-image">
        <img src={event.thumbnailUrl || placeholder} alt={event.name} loading="lazy" />
      </div>
      <div className="event-details">
        <h3>
          <TranslatedText text={event.name} dynamic />
        </h3>
        <div className="event-location">
          <span>{isEnglish ? 'Location:' : 'Konum:'}</span> <TranslatedText text={event.location} dynamic />
        </div>
        <div className="event-date">
          <span>{isEnglish ? 'Date:' : 'Tarih:'}</span> {event.date}
        </div>
        <div className="event-organizer">
          <span>
            {isEnglish ? 'Organizer:' : 'Organizatör:'} <TranslatedText text={event.organizer} dynamic />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default EventCard;
